import { Instance, SnapshotIn, types } from "mobx-state-tree";
import { withSetPropAction } from "mobx-stores/_extension/with-set-props";
import { Base, IBase } from "mobx-stores/_models/base";
import {
  IAddProductGoodsIssueItem,
  IUpdateProductGoodsIssueItem,
  ProductGoodsIssueItem,
} from "./product-goods-issue-item";

export const ProductGoodsIssue = types
  .compose(
    Base,
    types.model({
      exportDate: types.maybeNull(types.string),
      items: types.optional(types.array(ProductGoodsIssueItem), []),
    })
  )
  .actions(withSetPropAction);
export interface IProductGoodsIssue
  extends Instance<typeof ProductGoodsIssue> {}
export interface IProductGoodsIssueProperties
  extends SnapshotIn<typeof ProductGoodsIssue> {}

export interface IAddProductGoodsIssue
  extends Omit<IProductGoodsIssueProperties, keyof IBase> {
  items: IAddProductGoodsIssueItem[];
}

export interface IUpdateProductGoodsIssue
  extends Omit<IProductGoodsIssueProperties, "items"> {
  items: IUpdateProductGoodsIssueItem[];
}
